document.addEventListener('DOMContentLoaded', function () {

//   // Owl init only if exists
//   const slider = document.querySelector('.cart-notification-slider');
//   if (slider && typeof jQuery !== 'undefined') {
//     jQuery(slider).owlCarousel({
//       nav: false,
//       dots: true,
//       loop: false,
//       margin: 20,
//       rewind: true,
//       responsive: {
//         0: { items: 1 },
//         1200: { items: 1 }
//       }
//     });
//   }

  // Step form toggle
  document.addEventListener('click', function (e) {
    if (e.target.matches('.form-nextbtn')) {
      document.querySelector('.first_step')?.classList.add('hide');
      document.querySelector('.secound_step')?.classList.remove('hide');
    }

    if (e.target.matches('.form-backbtn')) {
      document.querySelector('.secound_step')?.classList.add('hide');
      document.querySelector('.first_step')?.classList.remove('hide');
    }
  });

  // AJAX Add to Cart
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ajax-add-to-cart');
    if (!btn) return;
    const variantId = btn.getAttribute('data-variantId');
    if (!variantId) return;

    btn.classList.add('btn--loading');

    fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(res => res.json())
      .then(data => {
        btn.classList.remove('btn--loading');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));
      })
      .catch(() => {
        btn.classList.remove('btn--loading');
      });
  });

});